import { useState } from "react";
import { Card, CardContent } from "../components/ui/card";
import {
  BookOpen, LayoutDashboard, Users, Calendar, CalendarDays, Calculator,
  FileSpreadsheet, CalendarCheck, Database, Settings, CreditCard, QrCode, Crown
} from "lucide-react";

const SECTIONS = [
  {
    id: "overview",
    icon: <BookOpen className="w-5 h-5" />,
    title: "はじめに",
    lead: "本マニュアルは、PRC勤怠の管理者向け機能の使い方をまとめた資料です。左のメニューから各機能の説明へ移動できます。",
    items: [
      "管理画面へは「管理者ログイン」からアクセスします。",
      "画面左のサイドバーから各機能に移動できます。",
      "スマートフォン・タブレットでも利用可能です（PWA対応）。",
    ],
  },
  {
    id: "dashboard",
    icon: <LayoutDashboard className="w-5 h-5" />,
    title: "ダッシュボード",
    lead: "当日の出勤状況や今月の勤怠サマリー、有給申請の状況を一目で確認できます。",
    items: [
      "出勤中・退勤済・未出勤・総従業員数を上部カードで確認。",
      "「今月のサマリー」で総労働時間・残業時間・記録件数を表示。",
      "クイックアクションから主要機能へワンタップで移動。",
      "有給申請の承認・却下をダッシュボード上で処理。",
    ],
  },
  {
    id: "employees",
    icon: <Users className="w-5 h-5" />,
    title: "従業員管理",
    lead: "従業員の登録・編集・削除、QRコードの発行を行います。",
    items: [
      "「新規登録」から氏名・従業員コード・雇用形態・母国語などを登録。",
      "各従業員のQRコードを発行・印刷し、打刻に利用。",
      "顔写真の登録により、打刻記録に写真を残せます。",
      "母国語を設定すると、打刻画面の表示と音声挨拶がその言語になります。",
    ],
  },
  {
    id: "attendance",
    icon: <Calendar className="w-5 h-5" />,
    title: "勤怠記録",
    lead: "打刻履歴の確認・追加・編集・削除、CSV出力・印刷を行います。",
    items: [
      "月・従業員で絞り込んで一覧表示。当日の記録は最上部に固定表示。",
      "過去の記録は「続きを見る」で展開できます。",
      "「新規追加」で手動の勤怠記録を追加、鉛筆アイコンで編集。",
      "「CSVエクスポート」で給与システム向けデータを出力。",
      "「印刷」で従業員ごとのタイムカードを出力（写真・集計付き）。",
    ],
  },
  {
    id: "shifts",
    icon: <CalendarDays className="w-5 h-5" />,
    title: "シフト管理",
    lead: "従業員ごとのシフトを作成・管理します。",
    items: [
      "カレンダー上でシフトパターンを割り当て。",
      "シフトテンプレートを使って効率的に登録。",
    ],
  },
  {
    id: "salary",
    icon: <Calculator className="w-5 h-5" />,
    title: "給与計算",
    lead: "勤怠データをもとに給与を集計します。",
    items: [
      "対象月を選択して労働時間・残業時間を集計。",
      "各種手当・控除を設定して支給額を算出。",
    ],
  },
  {
    id: "wage-ledger",
    icon: <FileSpreadsheet className="w-5 h-5" />,
    title: "賃金台帳",
    lead: "法定帳票である賃金台帳を作成・出力します。",
    items: [
      "従業員・年度を選択して賃金台帳を表示。",
      "月別・年間の支給・控除の内訳を確認しPDF出力。",
    ],
  },
  {
    id: "year-end",
    icon: <CalendarCheck className="w-5 h-5" />,
    title: "年末調整",
    lead: "年末調整に必要な情報の入力と計算を行います。",
    items: [
      "対象従業員・年を選択して控除情報を入力。",
      "計算結果を確認し、必要書類を出力。",
    ],
  },
  {
    id: "masters",
    icon: <Database className="w-5 h-5" />,
    title: "マスタ設定",
    lead: "雇用形態などのマスタデータを管理します。",
    items: [
      "「雇用形態」タブでカスタム雇用形態を追加・編集・削除。",
      "デフォルト（正社員・契約社員・パート等）は自動表示。",
    ],
  },
  {
    id: "settings",
    icon: <Settings className="w-5 h-5" />,
    title: "設定",
    lead: "企業情報・メール連携・締め日などの各種設定を行います。",
    items: [
      "会社名・住所などの企業情報を編集。",
      "Gmail連携やメール通知の設定。",
      "月末締め処理や年間カレンダー（休日）の設定。",
    ],
  },
  {
    id: "subscription",
    icon: <CreditCard className="w-5 h-5" />,
    title: "サブスクリプション",
    lead: "契約プランと請求状況を確認します。",
    items: [
      "現在のプラン・利用上限を確認。",
      "プランのアップグレード・請求履歴の確認。",
    ],
  },
  {
    id: "qr-auth",
    icon: <QrCode className="w-5 h-5" />,
    title: "QR打刻（認証画面）",
    lead: "従業員が実際に打刻を行う画面です。入口のタブレット等でご利用ください。",
    items: [
      "企業コードを入力後、従業員証のQRコードをかざすと自動で打刻。",
      "打刻後は従業員の母国語で挨拶メッセージと音声を再生。",
      "オフライン時もローカル保存し、オンライン復帰時に自動同期。",
      "音声が鳴らない場合は端末の音量・サイレントスイッチをご確認ください。",
    ],
  },
  {
    id: "super-admin",
    icon: <Crown className="w-5 h-5" />,
    title: "スーパー管理（サイト内容編集）",
    lead: "スーパー管理者のみ利用できる機能です。コーポレートサイトの内容を編集できます。",
    items: [
      "「サイト内容」タブから会社概要・料金・規約などの各ページを編集。",
      "各ページのタイトル・本文・ナビ/フッター表示を変更して保存。",
      "「お問い合わせ」フォームからの受信内容を確認。",
    ],
  },
];

export default function AdminManualPage() {
  const [active, setActive] = useState("overview");

  const scrollTo = (id) => {
    setActive(id);
    const el = document.getElementById(`manual-${id}`);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="space-y-6" data-testid="admin-manual-page">
      <div>
        <h1 className="text-2xl font-bold mb-1 flex items-center gap-2">
          <BookOpen className="w-6 h-6 text-emerald-400" />
          管理者マニュアル
        </h1>
        <p className="text-slate-400 text-sm">各機能の使い方をまとめた説明資料です。</p>
      </div>

      <div className="grid lg:grid-cols-[240px_1fr] gap-6">
        {/* 目次 */}
        <div className="lg:sticky lg:top-6 self-start">
          <Card className="bg-slate-800 border-slate-700">
            <CardContent className="p-3">
              <p className="text-xs text-slate-400 px-2 py-1 font-semibold">目次</p>
              <nav className="space-y-1">
                {SECTIONS.map((s) => (
                  <button
                    key={s.id}
                    onClick={() => scrollTo(s.id)}
                    data-testid={`manual-toc-${s.id}`}
                    className={`w-full flex items-center gap-2 px-2 py-2 rounded-lg text-left text-sm transition-colors ${
                      active === s.id ? "bg-emerald-600/20 text-emerald-400" : "text-slate-300 hover:bg-slate-700"
                    }`}
                  >
                    {s.icon}
                    <span>{s.title}</span>
                  </button>
                ))}
              </nav>
            </CardContent>
          </Card>
        </div>

        {/* 本文 */}
        <div className="space-y-5">
          {SECTIONS.map((s) => (
            <Card key={s.id} id={`manual-${s.id}`} className="bg-slate-800 border-slate-700 scroll-mt-6" data-testid={`manual-section-${s.id}`}>
              <CardContent className="p-6">
                <h2 className="text-lg font-semibold flex items-center gap-2 mb-2">
                  <span className="text-emerald-400">{s.icon}</span>
                  {s.title}
                </h2>
                <p className="text-slate-300 text-sm mb-4">{s.lead}</p>
                <ul className="list-disc pl-6 space-y-1.5 text-sm text-slate-400">
                  {s.items.map((it, i) => (
                    <li key={i}>{it}</li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
